import React from 'react';
import { Field, RadioGroup } from '../../../../Core';
import { ListFieldSection, FieldSet, PageSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';

let PreparationSection: React.FC = () => {
  return (
    <PageSection heading="Preparation">
      <ListFieldSection>
        <FieldSet>
          <Field
            input={<RadioGroup />}
            label="Preparation Method"
            name="Preparation.CompactionMethod.Id"
            options={['A', 'B', 'C', 'D'].map((e) => ({ label: e, value: e }))}
          />
        </FieldSet>
      </ListFieldSection>
    </PageSection>
  );
};

PreparationSection = withInjectedProps(PreparationSection);

export { PreparationSection };
export default PreparationSection;
